import { GET_DOC_ACCOUNTS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface AccountResponse {
    success: boolean;
    data?: DataEntity[] | null;
}
export interface DataEntity {
    name: Name;
    pic?: string;
    username: string;
    specialized: string;
    business?: {
        id: string;
        name: string;
        logo?: string;
    };
    _id: string;
}
export interface Name {
    l: string;
    f: string;
}

export const LS_DOCTOR_ACCOUNTS = 'docAccounts';

export default (): Promise<AccountResponse> => {
    return fetchWithRefresh(GET_DOC_ACCOUNTS).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed GET_DOC_ACCOUNTS');
        }
    });
};
